function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 153.76343,
  cy: 699.22893,
  rx: 92.33742,
  ry: 15,
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "705.618 632.278 334.02 554.861 334.02 193.936 705.618 0 705.618 632.278",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "704.716 37.901 333.118 215.757 333.118 194.838 704.716 1.227 704.716 37.901",
  fill: "#c84d69"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M597.44592,290.43592c0,4.81337-1.62158,9.49559-3.60775,10.45124-1.97073.94821-3.55712-2.13575-3.55712-6.88156s1.58639-9.41051,3.55712-10.426C595.82434,282.55613,597.44592,285.62255,597.44592,290.43592Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M611.87691,283.23273c0,4.68012-1.6214,9.25023-3.60775,10.201-1.97133.94361-3.55849-2.03886-3.55849-6.6551s1.58716-9.1694,3.55849-10.17665C610.25551,275.58707,611.87691,278.5526,611.87691,283.23273Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#e6e6e6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M626.3079,276.01723c0,4.68013-1.6214,9.25023-3.60775,10.201-1.97132.94361-3.55849-2.03887-3.55849-6.6551s1.58717-9.1694,3.55849-10.17666C624.6865,268.37157,626.3079,271.3371,626.3079,276.01723Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#e6e6e6"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "609.147 281.46 380.055 333.87 380.055 267.029 609.147 186.037 609.147 281.46",
  opacity: 0.2
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "604.601 276.914 375.509 329.325 375.509 262.483 604.601 181.491 604.601 276.914",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M665.11272,380.73665c0,10.76876-4.07337,20.541-9.01937,21.80684-4.8611,1.24408-8.741-6.22334-8.741-16.65973s3.8799-20.15266,8.741-21.72617C661.03935,362.5566,665.11272,369.96788,665.11272,380.73665Z",
  transform: "translate(-247.19089 -92.88554)",
  opacity: 0.2
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M662.38538,378.00931c0,10.76876-4.07337,20.541-9.01937,21.80685-4.8611,1.24407-8.741-6.22334-8.741-16.65974s3.87989-20.15266,8.741-21.72617C658.312,359.82926,662.38538,367.24055,662.38538,378.00931Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#c84d69"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "549.583 246.931 439.547 278.704 439.547 267.458 549.583 233.622 549.583 246.931",
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  points: "524.329 279.098 459.389 295.49 459.389 283.872 524.329 266.263 524.329 279.098",
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "609.154 520.473 380.062 501.27 380.062 367.144 609.154 328.898 609.154 520.473",
  opacity: 0.2
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  points: "603.699 515.928 374.607 496.724 374.607 362.598 603.699 324.352 603.699 515.928",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  points: "412.503 400.494 401.781 401.493 401.781 389.773 412.503 388.549 412.503 400.494",
  opacity: 0.2
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "410.685 398.676 399.963 399.675 399.963 387.954 410.685 386.731 410.685 398.676",
  fill: "#c84d69"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "549.583 385.456 421.508 397.443 421.508 386.535 549.583 372.147 549.583 385.456",
  fill: "#e6e6e6"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "549.583 428.914 421.508 433.059 421.508 422.152 549.583 415.605 549.583 428.914",
  fill: "#e6e6e6"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "549.583 473.472 421.508 469.578 421.508 458.67 549.583 460.163 549.583 473.472",
  fill: "#e6e6e6"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  points: "143.363 329.249 118.852 329.249 118.852 317.244 139.361 317.244 143.863 319.745 143.363 329.249",
  fill: "#575a89"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "100.843 659.902 101.844 677.911 116.851 674.909 114.35 656.901 100.843 659.902",
  fill: "#ffb9b9"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M419.06715,743.28358s.50023,15.007-1.00046,19.00882,4.00185,6.00278,4.00185,6.00278h12.00557l7.00325,1.00047v-7.50348s-8.00371-12.5058-8.00371-19.50905S419.06715,743.28358,419.06715,743.28358Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#ffb9b9"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M350.53537,767.795s10.00464-4.7266,13.50627-1.86307,16.50765,27.3749,11.50533,28.8756c0,0-3.50162,6.00278-15.50719,2.00092s-12.00557-8.50394-12.00557-8.50394-3.50162-3.00139-3.50162-4.00185,1.50069-10.00464,1.50069-10.00464,1.11-7.53342,2.806-7.01822Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M420.06762,760.29147s-1.5007-1.5007-2.50116,0-6.503,20.50951-1.5007,21.51,12.5058,4.50208,13.50626,3.50162a13.70429,13.70429,0,0,0,2.00093-3.50162s8.00371,3.50162,10.50487,6.503,32.51508,9.50441,31.51462,0S457.585,770.79634,457.585,770.79634l-16.50765-11.0051s-6.503.50023-8.00371,3.50162S421.06808,765.794,420.06762,760.29147Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M273.49965,566.7017s-5.50255,7.00324-4.50209,7.50348,23.01067,5.50255,35.01624,2.50116,37.01716-2.50116,38.51786-6.00279,20.00928-47.0218,20.00928-47.0218l-6.00278-33.01531-6.503-8.504-15.007-13.006-30.01392,56.026Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#575a89"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M273.49965,566.7017s-5.50255,7.00324-4.50209,7.50348,23.01067,5.50255,35.01624,2.50116,37.01716-2.50116,38.51786-6.00279,20.00928-47.0218,20.00928-47.0218l-6.00278-33.01531-6.503-8.504-15.007-13.006-30.01392,56.026Z",
  transform: "translate(-247.19089 -92.88554)",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M337.02911,554.69613s-7.00325,25.0116,0,59.5276.50023,42.01949,2.00093,43.52019,2.00092,1.00046,2.00092,2.50116,1.5007,8.50394,0,11.0051-1.50069,82.038,3.0014,84.039,17.50812,7.00325,20.00928,0,.50023-57.52668,1.50069-60.02784,1.00047-8.50394,1.00047-10.00464,3.00139-18.50858,3.50162-23.01067,2.00093-13.50626,2.00093-13.50626-1.00047-35.51647,2.00092-46.02134,4.00186-11.50534,4.00186-11.50534l24.01114,62.529s-2.00093,6.503,0,8.50394-.50024,1.5007,1.50069,5.00232,4.00186,4.50209,4.00186,6.503-2.00093,2.00093-1.00047,3.50162,2.50116,7.00325,2.50116,7.00325l-2.50116,6.00278s1.5007,12.5058,3.50163,20.00928,2.00092,38.01763,4.50208,38.51787,22.01021,6.00278,22.01021-5.50256-1.50069-61.52853-1.50069-61.52853-3.0014-7.50348-3.0014-9.50441-.50023-3.00139.50024-4.00185,2.00092-3.00139.50023-4.50209-1.00047-3.50162-1.00047-5.50255a43.78248,43.78248,0,0,0-1.00046-8.00371c-.50023-2.00093-10.00464-64.52993-10.00464-64.52993s2.00093-7.50348,0-8.00371-2.00093-4.50209-2.00093-6.503,5.00232-27.01252-1.00046-27.01252S337.02911,554.69613,337.02911,554.69613Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M270.99849,524.68221l-7.00325,3.50162s-25.0116,13.50627-14.00649,21.00975,22.0102-10.50487,22.0102-10.50487l10.50487-8.00372Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#ffb9b9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M368.54372,387.61865s-2.00092,23.01067-12.5058,28.013-3.50162,42.51972-3.50162,42.51972L367.043,472.15785l25.51183-7.50348,3.00139-17.00788,2.50116-17.50812-6.00278-9.00418s-7.50348-2.00093-4.50209-22.0102S368.54372,387.61865,368.54372,387.61865Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#ffb9b9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M353.53676,423.63535S365.0421,461.653,373.04581,461.653s12.5058-9.00417,13.50626-20.00928,7.50348-23.01067,7.50348-23.01067l15.5072,14.0065s12.50579,110.55126,11.50533,113.55266-40.01856,6.503-55.52575,11.0051-31.01438,1.00046-31.01438-1.5007c0-2.22759,7.93581-21.51718,1.89715-35.60509a58.68566,58.68566,0,0,1-4.431-15.754c-.9346-7.41645-1.80254-16.39091-.96773-19.1736,1.50069-5.00231,9.5044-58.0269,9.5044-58.0269Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#c84d69"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M362.0065,409.83305s-8.97,4.79813-12.97182,6.799-28.51323,8.00372-29.01346,11.00511,3.50163,45.02088,1.5007,49.523-22.01021,44.52065-22.01021,44.52065l-1.00046,8.50394s-33.01531,39.51833-29.01346,44.02042,19.00882-14.0065,19.00882-14.0065,33.51554-53.52482,34.516-55.52575,21.51-39.01809,24.51137-40.01856,10.00464-43.01995,11.0051-45.02087S363.473,409.03677,362.0065,409.83305Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#575a89"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M322.52238,427.137H319.521s-11.0051,42.01948-14.0065,47.522-3.50162,14.50673-4.00185,16.00743-2.50116,1.00046-3.00139,4.50208-5.50255,8.00372-9.50441,10.00464-22.01021,19.00882-21.51,19.50905,6.00279,18.00835,9.50441,18.00835,17.50812-17.00789,19.00882-17.00789,8.00371-6.00278,9.00417-6.503,26.5123-47.522,25.51183-59.02737S322.52238,427.137,322.52238,427.137Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#575a89"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M447.33687,556.73349l6.16157,4.83134s21.80557,18.235,9.52228,23.38626-19.465-14.69407-19.465-14.69407l-8.69219-9.94271Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#ffb9b9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M386.94112,410.42594s6.6142,3.20477,9.61559,5.70593,26.01207,9.00418,26.01207,11.00511-2.50116,33.01531-2.50116,33.01531l3.50162,55.02551s5.00232,62.02877,6.00278,63.52946,2.50116,9.50441,0,9.50441-15.007-14.00649-14.50672-21.00974,4.00185-23.01067.50023-27.01253-20.00928-71.03294-20.00928-75.03479-7.00325-44.02042-6.503-45.02088S386.94112,410.42594,386.94112,410.42594Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#575a89"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M415.0653,426.63674l7.50348.50024,18.50858,75.535s1.5007,9.50441,2.00093,10.50488,8.00371,44.52064,5.00232,46.02134-13.006,7.00324-13.50627,3.50162-5.50255-23.01067-10.50487-27.51276-10.00464-82.038-10.00464-82.038Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#575a89"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.86049,
  cy: 287.72987,
  r: 20.50951,
  fill: "#ffb9b9"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M370.73859,382.11329c1.305-.67033,3.02215-.03939,4.22669,1.41963a20.01784,20.01784,0,0,1,29.09491-13.52556V367.9225a17.321,17.321,0,0,0-17.321-17.321h-4.1633a32.54068,32.54068,0,0,0-32.54073,32.54067V388.95a29.17453,29.17453,0,0,0,15.97665,26.02122L384.7424,405.055a20.02023,20.02023,0,0,1-10.02687-14.87357c-1.58509.6921-3.70777-.428-4.812-2.57779C368.76734,385.39191,369.14129,382.9338,370.73859,382.11329Z",
  transform: "translate(-247.19089 -92.88554)",
  fill: "#2f2e41"
});

function SvgBrowsing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aee07f99-5223-45c5-8204-b56b0229636c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 705.61822,
    height: 714.22893,
    viewBox: "0 0 705.61822 714.22893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "browsing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsing);
export default __webpack_public_path__ + "static/media/browsing.b56ffd0d.svg";
export { ForwardRef as ReactComponent };